import { animation, style, animate, keyframes } from '@angular/animations';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
const /** @type {?} */ DEFAULT_TIMING = 1;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
const /** @type {?} */ bounce = animation([
    style({ transform: 'translate3d(0, 0, 0)' }),
    animate('{{ timing }}s {{ delay }}s', keyframes([
        style({ transform: 'translate3d(0, 0, 0)', offset: 0.2 }),
        style({ transform: 'translate3d(0, -30px, 0)', offset: 0.4 }),
        style({ transform: 'translate3d(0, 0, 0)', offset: 0.53 }),
        style({ transform: 'translate3d(0, -15px, 0)', offset: 0.7 }),
        style({ transform: 'translate3d(0, -4px, 0)', offset: 0.9 }),
        style({ transform: 'translate3d(0, 0, 0)', offset: 1 }),
    ])),
], { params: { timing: DEFAULT_TIMING, delay: 0 } });
const /** @type {?} */ flash = animation(animate('{{ timing }}s {{ delay }}s', keyframes([
    style({ opacity: 1 }),
    style({ opacity: 0 }),
    style({ opacity: 1 }),
    style({ opacity: 0 }),
    style({ opacity: 1 }),
])), { params: { timing: DEFAULT_TIMING, delay: 0 } });
const /** @type {?} */ pulse = animation(animate('{{ timing }}s {{ delay }}s', keyframes([
    style({ transform: 'scale3d(1, 1, 1)' }),
    style({ transform: 'scale3d({{ scale }}, {{ scale }}, {{ scale }})' }),
    style({ transform: 'scale3d(1, 1, 1)' }),
])), { params: { scale: 1.25, timing: DEFAULT_TIMING, delay: 0 } });
const /** @type {?} */ rubberBand = animation(animate('{{ timing }}s {{ delay }}s', keyframes([
    style({ transform: 'scale3d(1, 1, 1)', offset: 0 }),
    style({ transform: 'scale3d(1.25, 0.75, 1)', offset: 0.3 }),
    style({ transform: 'scale3d(0.75, 1.25, 1)', offset: 0.4 }),
    style({ transform: 'scale3d(1.15, 0.85, 1)', offset: 0.5 }),
    style({ transform: 'scale3d(.95, 1.05, 1)', offset: 0.65 }),
    style({ transform: 'scale3d(1.05, .95, 1)', offset: 0.75 }),
    style({ transform: 'scale3d(1, 1, 1)', offset: 1 }),
])), { params: { timing: DEFAULT_TIMING, delay: 0 } });
const /** @type {?} */ shake = animation(animate('{{ timing }}s {{ delay }}s', keyframes([
    style({ transform: 'translate3d(0, 0, 0)', offset: 0 }),
    style({ transform: 'translate3d(-10px, 0, 0)', offset: 0.1 }),
    style({ transform: 'translate3d(10px, 0, 0)', offset: 0.2 }),
    style({ transform: 'translate3d(-10px, 0, 0)', offset: 0.3 }),
    style({ transform: 'translate3d(10px, 0, 0)', offset: 0.4 }),
    style({ transform: 'translate3d(-10px, 0, 0)', offset: 0.5 }),
    style({ transform: 'translate3d(10px, 0, 0)', offset: 0.6 }),
    style({ transform: 'translate3d(-10px, 0, 0)', offset: 0.7 }),
    style({ transform: 'translate3d(10px, 0, 0)', offset: 0.8 }),
    style({ transform: 'translate3d(-10px, 0, 0)', offset: 0.9 }),
    style({ transform: 'translate3d(0, 0, 0)', offset: 1 }),
])), { params: { timing: DEFAULT_TIMING, delay: 0 } });
const /** @type {?} */ swing = animation(animate('{{ timing }}s {{ delay }}s', keyframes([
    style({ transform: 'rotate3d(0, 0, 1, 15deg)', offset: 0.2 }),
    style({ transform: 'rotate3d(0, 0, 1, -10deg)', offset: 0.4 }),
    style({ transform: 'rotate3d(0, 0, 1, 5deg)', offset: 0.6 }),
    style({ transform: 'rotate3d(0, 0, 1, -5deg)', offset: 0.8 }),
    style({ transform: 'rotate3d(0, 0, 1, 0deg)', offset: 1 }),
])), { params: { timing: DEFAULT_TIMING, delay: 0 } });
const /** @type {?} */ tada = animation(animate('{{ timing }}s {{ delay }}s', keyframes([
    style({ transform: 'scale3d(1, 1, 1)', offset: 0 }),
    style({
        transform: 'scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg)',
        offset: 0.1,
    }),
    style({
        transform: 'scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg)',
        offset: 0.2,
    }),
    style({
        transform: 'scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg)',
        offset: 0.3,
    }),
    style({
        transform: 'scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg)',
        offset: 0.4,
    }),
    style({
        transform: 'scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg)',
        offset: 0.5,
    }),
    style({
        transform: 'scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg)',
        offset: 0.6,
    }),
    style({
        transform: 'scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg)',
        offset: 0.7,
    }),
    style({
        transform: 'scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg)',
        offset: 0.8,
    }),
    style({
        transform: 'scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg)',
        offset: 0.9,
    }),
    style({ transform: 'scale3d(1, 1, 1)', offset: 1 }),
])), { params: { timing: DEFAULT_TIMING, delay: 0 } });
const /** @type {?} */ wobble = animation(animate('{{ timing }}s {{ delay }}s', keyframes([
    style({ transform: 'none', offset: 0 }),
    style({
        transform: 'translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg)',
        offset: 0.15,
    }),
    style({
        transform: 'translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg)',
        offset: 0.3,
    }),
    style({
        transform: 'translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg)',
        offset: 0.45,
    }),
    style({
        transform: 'translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg)',
        offset: 0.6,
    }),
    style({
        transform: 'translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg)',
        offset: 0.75,
    }),
    style({ transform: 'none', offset: 1 }),
])), { params: { timing: DEFAULT_TIMING, delay: 0 } });
const /** @type {?} */ jello = animation(animate('{{ timing }}s {{ delay }}s', keyframes([
    style({ transform: 'none', offset: 0 }),
    style({ transform: 'none', offset: 0.11 }),
    style({ transform: 'skewX(-12.5deg) skewY(-12.5deg)', offset: 0.22 }),
    style({ transform: 'skewX(6.25deg) skewY(6.25deg)', offset: 0.33 }),
    style({ transform: 'skewX(-3.125deg) skewY(-3.125deg)', offset: 0.44 }),
    style({ transform: 'skewX(1.5625deg) skewY(1.5625deg)', offset: 0.55 }),
    style({
        transform: 'skewX(-0.78125deg) skewY(-0.78125deg)',
        offset: 0.66,
    }),
    style({
        transform: 'skewX(0.390625deg) skewY(0.390625deg)',
        offset: 0.77,
    }),
    style({
        transform: 'skewX(-0.1953125deg) skewY(-0.1953125deg)',
        offset: 0.88,
    }),
    style({ transform: 'none', offset: 1 }),
])), { params: { timing: DEFAULT_TIMING, delay: 0 } });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
const /** @type {?} */ bounceIn = animation(animate('{{ timing }}s {{ delay }}s cubic-bezier(0.215, 0.610, 0.355, 1.000)', keyframes([
    style({ opacity: 0, transform: 'scale3d(.3, .3, .3)', offset: 0 }),
    style({ transform: 'scale3d(1.1, 1.1, 1.1)', offset: 0.2 }),
    style({ transform: 'scale3d(.9, .9, .9)', offset: 0.4 }),
    style({
        opacity: 1,
        transform: 'scale3d(1.03, 1.03, 1.03)',
        offset: 0.6
    }),
    style({ transform: 'scale3d(.97, .97, .97)', offset: 0.8 }),
    style({ opacity: 1, transform: 'scale3d(1, 1, 1)', offset: 1 })
])), { params: { timing: DEFAULT_TIMING, delay: 0 } });
/**
 * @param {?} a
 * @param {?} b
 * @param {?} c
 * @param {?} d
 * @return {?}
 */
function bounceInY(a, b, c, d) {
    return animation(animate('{{ timing }}s {{ delay }}s cubic-bezier(0.215, 0.610, 0.355, 1.000)', keyframes([
        style({
            opacity: 0,
            transform: 'translate3d(0, {{ a }}, 0)',
            offset: 0
        }),
        style({
            opacity: 1,
            transform: 'translate3d(0, {{ b }}, 0)',
            offset: 0.6
        }),
        style({ transform: 'translate3d(0, {{ c }}, 0)', offset: 0.75 }),
        style({ transform: 'translate3d(0, {{ d }}, 0)', offset: 0.9 }),
        style({ opacity: 1, transform: 'none', offset: 1 })
    ])), {
        params: {
            timing: DEFAULT_TIMING,
            delay: 0,
            a,
            b,
            c,
            d
        }
    });
}
/**
 * @param {?} a
 * @param {?} b
 * @param {?} c
 * @param {?} d
 * @return {?}
 */
function bounceInX(a, b, c, d) {
    return animation(animate('{{ timing }}s {{ delay }}s cubic-bezier(0.215, 0.610, 0.355, 1.000)', keyframes([
        style({
            opacity: 0,
            transform: 'translate3d({{ a }}, 0, 0)',
            offset: 0
        }),
        style({
            opacity: 1,
            transform: 'translate3d({{ b }}, 0, 0)',
            offset: 0.6
        }),
        style({ transform: 'translate3d({{ c }}, 0, 0)', offset: 0.75 }),
        style({ transform: 'translate3d({{ d }}, 0, 0)', offset: 0.9 }),
        style({ opacity: 1, transform: 'none', offset: 1 })
    ])), {
        params: {
            timing: DEFAULT_TIMING,
            delay: 0,
            a,
            b,
            c,
            d
        }
    });
}
const /** @type {?} */ bounceInDown = bounceInY('-3000px', '25px', '-10px', '5px');
const /** @type {?} */ bounceInUp = bounceInY('3000px', '-25px', '10px', '-5px');
const /** @type {?} */ bounceInLeft = bounceInX('-3000px', '25px', '-10px', '5px');
const /** @type {?} */ bounceInRight = bounceInX('3000px', '-25px', '10px', '-5px');
const /** @type {?} */ bounceOut = animation(animate('{{ timing }}s {{ delay }}s', keyframes([
    style({ transform: 'scale3d(.9, .9, .9)', offset: 0.2 }),
    style({
        opacity: 1,
        transform: 'scale3d({{ scale }}, {{ scale }}, {{ scale }})',
        offset: 0.5
    }),
    style({
        opacity: 1,
        transform: 'scale3d({{ scale }}, {{ scale }}, {{ scale }})',
        offset: 0.55
    }),
    style({ opacity: 0, transform: 'scale3d(.3, .3, .3)', offset: 1 })
])), { params: { timing: DEFAULT_TIMING, delay: 0, scale: 1.1 } });
/**
 * @param {?} a
 * @param {?} b
 * @param {?} c
 * @param {?} d
 * @return {?}
 */
function bounceOutY(a, b, c, d) {
    return animation(animate('{{ timing }}s {{ delay }}s', keyframes([
        style({ transform: 'translate3d(0, {{ a }}, 0)', offset: 0.2 }),
        style({
            opacity: 1,
            transform: 'translate3d(0, {{ b }}, 0)',
            offset: 0.4
        }),
        style({
            opacity: 1,
            transform: 'translate3d(0, {{ c }}, 0)',
            offset: 0.45
        }),
        style({
            opacity: 0,
            transform: 'translate3d(0, {{ d }}, 0)',
            offset: 1
        })
    ])), {
        params: {
            timing: DEFAULT_TIMING,
            delay: 0,
            a,
            b,
            c,
            d
        }
    });
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function bounceOutX(a, b) {
    return animation(animate('{{ timing }}s {{ delay }}s', keyframes([
        style({
            opacity: 1,
            transform: 'translate3d({{ a }}, 0, 0)',
            offset: 0.2
        }),
        style({
            opacity: 0,
            transform: 'translate3d({{ b }}, 0, 0)',
            offset: 1
        })
    ])), { params: { timing: DEFAULT_TIMING, delay: 0, a, b } });
}
const /** @type {?} */ bounceOutDown = bounceOutY('10px', '-20px', '-20px', '2000px');
const /** @type {?} */ bounceOutUp = bounceOutY('-10px', '20px', '20px', '-2000px');
const /** @type {?} */ bounceOutLeft = bounceOutX('20px', '-2000px');
const /** @type {?} */ bounceOutRight = bounceOutX('-20px', '2000px');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function fadeInX(a, b) {
    return animation(animate('{{ timing }}s {{ delay }}s', keyframes([
        style({
            opacity: 0,
            transform: 'translate3d({{ a }}, 0, 0)',
            offset: 0
        }),
        style({
            opacity: 1,
            transform: 'translate3d({{ b }}, 0, 0)',
            offset: 1
        })
    ])), { params: { timing: DEFAULT_TIMING, delay: 0, a, b } });
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function fadeInY(a, b) {
    return animation(animate('{{ timing }}s {{ delay }}s', keyframes([
        style({
            opacity: 0,
            transform: 'translate3d(0, {{ a }}, 0)',
            offset: 0
        }),
        style({
            opacity: 1,
            transform: 'translate3d(0, {{ b }}, 0)',
            offset: 1
        })
    ])), { params: { timing: DEFAULT_TIMING, delay: 0, a, b } });
}
const /** @type {?} */ fadeIn = fadeInX(0, 0);
const /** @type {?} */ fadeInDown = fadeInY('-100%', 0);
const /** @type {?} */ fadeInUp = fadeInY('100%', 0);
const /** @type {?} */ fadeInLeft = fadeInX('-100%', 0);
const /** @type {?} */ fadeInRight = fadeInX('100%', 0);
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function fadeOutX(a, b) {
    return animation(animate('{{ timing }}s {{ delay }}s', keyframes([
        style({
            opacity: 1,
            transform: 'translate3d({{ a }}, 0, 0)',
            offset: 0
        }),
        style({
            opacity: 0,
            transform: 'translate3d({{ b }}, 0, 0)',
            offset: 1
        })
    ])), { params: { timing: DEFAULT_TIMING, delay: 0, a, b } });
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function fadeOutY(a, b) {
    return animation(animate('{{ timing }}s {{ delay }}s', keyframes([
        style({
            opacity: 1,
            transform: 'translate3d(0, {{ a }}, 0)',
            offset: 0
        }),
        style({
            opacity: 0,
            transform: 'translate3d(0, {{ b }}, 0)',
            offset: 1
        })
    ])), { params: { timing: DEFAULT_TIMING, delay: 0, a, b } });
}
const /** @type {?} */ fadeOut = fadeOutX(0, 0);
const /** @type {?} */ fadeOutDown = fadeOutY('-100%', 0);
const /** @type {?} */ fadeOutUp = fadeOutY('100%', 0);
const /** @type {?} */ fadeOutLeft = fadeOutX('-100%', 0);
const /** @type {?} */ fadeOutRight = fadeOutX('100%', 0);
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function slideX(a, b) {
    return animation(animate('{{ timing }}s {{ delay }}s', keyframes([
        style({
            transform: 'translate3d({{ a }}, 0, 0)',
            offset: 0
        }),
        style({
            transform: 'translate3d({{ b }}, 0, 0)',
            offset: 1
        })
    ])), { params: { timing: DEFAULT_TIMING, delay: 0, a, b } });
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function slideY(a, b) {
    return animation(animate('{{ timing }}s {{ delay }}s', keyframes([
        style({
            transform: 'translate3d(0, {{ a }}, 0)',
            offset: 0
        }),
        style({
            transform: 'translate3d(0, {{ b }}, 0)',
            offset: 1
        })
    ])), { params: { timing: DEFAULT_TIMING, delay: 0, a, b } });
}
const /** @type {?} */ slideInUp = slideY('-100%', 0);
const /** @type {?} */ slideInDown = slideY('100%', 0);
const /** @type {?} */ slideInLeft = slideX('-100%', 0);
const /** @type {?} */ slideInRight = slideX('100%', 0);
const /** @type {?} */ slideOutUp = slideY(0, '-100%');
const /** @type {?} */ slideOutDown = slideY(0, '100%');
const /** @type {?} */ slideOutLeft = slideX(0, '-100%');
const /** @type {?} */ slideOutRight = slideX(0, '100%');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
const /** @type {?} */ flip = animation([
    style({ 'backface-visibility': 'visible' }),
    animate('{{ timing }}s {{ delay }}s ease-out', keyframes([
        style({
            transform: 'perspective(400px) rotate3d(0, 1, 0, -360deg)',
            offset: 0
        }),
        style({
            transform: 'perspective(400px) scale3d(1.5, 1.5, 1.5) rotate3d(0, 1, 0, -190deg)',
            offset: 0.4
        }),
        style({
            transform: 'perspective(400px) scale3d(1.5, 1.5, 1.5) rotate3d(0, 1, 0, -170deg)',
            offset: 0.5
        }),
        style({
            transform: 'perspective(400px) scale3d(.95, .95, .95)',
            offset: 0.8
        }),
        style({
            transform: 'perspective(400px)',
            offset: 1
        })
    ]))
], {
    params: { timing: DEFAULT_TIMING, delay: 0 }
});
/**
 * @param {?} rotateX
 * @param {?} rotateY
 * @return {?}
 */
function flipIn(rotateX, rotateY) {
    return animation([
        style({ 'backface-visibility': 'visible' }),
        animate('{{ timing }}s {{ delay }}s ease-in', keyframes([
            style({
                opacity: 0,
                transform: 'perspective(400px) rotate3d({{ rotateX }}, {{ rotateY }}, 0, 90deg)',
                offset: 0
            }),
            style({
                opacity: 1,
                transform: 'perspective(400px) rotate3d({{ rotateX }}, {{ rotateY }}, 0, -20deg)',
                offset: 0.4
            }),
            style({
                transform: 'perspective(400px) rotate3d({{ rotateX }}, {{ rotateY }}, 0, 10deg)',
                offset: 0.6
            }),
            style({
                transform: 'perspective(400px) rotate3d({{ rotateX }}, {{ rotateY }}, 0, -5deg)',
                offset: 0.8
            }),
            style({
                transform: 'perspective(400px) rotate3d(0, 0, 0, 0)',
                offset: 1
            })
        ]))
    ], { params: { timing: DEFAULT_TIMING, delay: 0, rotateX, rotateY } });
}
const /** @type {?} */ flipInX = flipIn(1, 0);
const /** @type {?} */ flipInY = flipIn(0, 1);
/**
 * @param {?} rotateX
 * @param {?} rotateY
 * @return {?}
 */
function flipOut(rotateX, rotateY) {
    return animation([
        style({ 'backface-visibility': 'visible' }),
        animate('{{ timing }}s {{ delay }}s', keyframes([
            style({
                transform: 'perspective(400px)',
                offset: 0
            }),
            style({
                opacity: 1,
                transform: 'perspective(400px) rotate3d({{ rotateX }}, {{ rotateY }}, 0, -20deg)',
                offset: 0.3
            }),
            style({
                opacity: 0,
                transform: 'perspective(400px) rotate3d({{ rotateX }}, {{ rotateY }}, 0, 90deg)',
                offset: 1
            })
        ]))
    ], { params: { timing: DEFAULT_TIMING, delay: 0, rotateX, rotateY } });
}
const /** @type {?} */ flipOutX = flipOut(1, 0);
const /** @type {?} */ flipOutY = flipOut(0, 1);

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
const /** @type {?} */ lightSpeedIn = animation(animate('{{ timing }}s {{ delay }}s', keyframes([
    style({
        opacity: 0,
        transform: 'translate3d(100%, 0, 0) skewX(-30deg)',
        offset: 0,
    }),
    style({
        opacity: 1,
        transform: 'translate3d(0, 0, 0) skewX(0)',
        offset: 1,
    }),
])), {
    params: { timing: DEFAULT_TIMING, delay: 0 },
});
const /** @type {?} */ lightSpeedOut = animation(animate('{{ timing }}s {{ delay }}s ease-out', keyframes([
    style({
        opacity: 1,
        offset: 0,
    }),
    style({
        opacity: 0,
        transform: 'translate3d(100%, 0, 0) skewX(30deg)',
        offset: 1,
    }),
])), {
    params: { timing: DEFAULT_TIMING, delay: 0 },
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @param {?} origin
 * @param {?} degrees
 * @return {?}
 */
function rotateInDirection(origin, degrees) {
    return animation(animate('{{ timing }}s {{ delay }}s', keyframes([
        style({
            'transform-origin': '{{ origin }}',
            opacity: 0,
            transform: 'rotate3d(0, 0, 1, {{ degrees }})',
            offset: 0
        }),
        style({
            'transform-origin': '{{ origin }}',
            opacity: 1,
            transform: 'none',
            offset: 1
        })
    ])), {
        params: { timing: DEFAULT_TIMING, delay: 0, origin, degrees }
    });
}
const /** @type {?} */ rotateIn = rotateInDirection('center', '-200deg');
const /** @type {?} */ rotateInDownLeft = rotateInDirection('left bottom', '-45deg');
const /** @type {?} */ rotateInDownRight = rotateInDirection('right bottom', '45deg');
const /** @type {?} */ rotateInUpLeft = rotateInDirection('left bottom', '45deg');
const /** @type {?} */ rotateInUpRight = rotateInDirection('right bottom', '-90deg');
/**
 * @param {?} origin
 * @param {?} degrees
 * @return {?}
 */
function rotateOutDirection(origin, degrees) {
    return animation(animate('{{ timing }}s {{ delay }}s', keyframes([
        style({
            'transform-origin': '{{ origin }}',
            opacity: 1,
            transform: 'none',
            offset: 0
        }),
        style({
            'transform-origin': '{{ origin }}',
            opacity: 0,
            transform: 'rotate3d(0, 0, 1, {{ degrees }})',
            offset: 1
        })
    ])), {
        params: { timing: DEFAULT_TIMING, delay: 0, origin, degrees }
    });
}
const /** @type {?} */ rotateOut = rotateOutDirection('center', '200deg');
const /** @type {?} */ rotateOutDownLeft = rotateOutDirection('left bottom', '45deg');
const /** @type {?} */ rotateOutDownRight = rotateOutDirection('right bottom', '-45deg');
const /** @type {?} */ rotateOutUpLeft = rotateOutDirection('left bottom', '-45deg');
const /** @type {?} */ rotateOutUpRight = rotateOutDirection('right bottom', '90deg');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
const /** @type {?} */ hinge = animation([
    style({ 'transform-origin': 'top left' }),
    animate('{{ timing }}s {{ delay }}s ease-in-out', keyframes([
        style({
            transform: 'rotate3d(0, 0, 1, 80deg)',
            offset: 0.2,
        }),
        style({
            transform: 'rotate3d(0, 0, 1, 60deg)',
            offset: 0.4,
        }),
        style({
            transform: 'rotate3d(0, 0, 1, 80deg)',
            offset: 0.6,
        }),
        style({
            opacity: 1,
            transform: 'rotate3d(0, 0, 1, 60deg)',
            offset: 0.8,
        }),
        style({
            opacity: 0,
            transform: 'translate3d(0, 700px, 0)',
            offset: 1,
        }),
    ])),
], {
    params: { timing: DEFAULT_TIMING, delay: 0 },
});
const /** @type {?} */ jackInTheBox = animation([
    animate('{{ timing }}s {{ delay }}s', keyframes([
        style({
            opacity: 0,
            transform: 'scale(0.1) rotate(30deg)',
            'transform-origin': 'center bottom',
            offset: 0,
        }),
        style({
            opacity: 0.5,
            transform: 'rotate(-10deg)',
            offset: 0.5,
        }),
        style({
            opacity: 0.7,
            transform: 'rotate(3deg)',
            offset: 0.7,
        }),
        style({
            opacity: 1,
            transform: 'scale(1)',
            offset: 1,
        }),
    ])),
], {
    params: { timing: DEFAULT_TIMING, delay: 0 },
});
const /** @type {?} */ rollIn = animation([
    animate('{{ timing }}s {{ delay }}s', keyframes([
        style({
            opacity: 0,
            transform: 'translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg)',
            offset: 0,
        }),
        style({
            opacity: 1,
            transform: 'none',
            offset: 1,
        }),
    ])),
], {
    params: { timing: DEFAULT_TIMING, delay: 0 },
});
const /** @type {?} */ rollOut = animation([
    animate('{{ timing }}s {{ delay }}s', keyframes([
        style({
            opacity: 1,
            offset: 0,
        }),
        style({
            opacity: 0,
            transform: 'translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg)',
            offset: 1,
        }),
    ])),
], {
    params: { timing: DEFAULT_TIMING, delay: 0 },
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
const /** @type {?} */ zoomIn = animation([
    animate('{{ timing }}s {{ delay }}s', keyframes([
        style({
            opacity: 0,
            transform: 'scale3d(.3, .3, .3)',
            offset: 0
        }),
        style({
            opacity: 1,
            transform: 'scale3d(1, 1, 1)',
            offset: 0.5
        })
    ]))
], {
    params: { timing: DEFAULT_TIMING, delay: 0 }
});
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function zoomInY(a, b) {
    return animation(animate('{{ timing }}s {{ delay }}s cubic-bezier(0.550, 0.055, 0.675, 0.190)', keyframes([
        style({
            opacity: 0,
            transform: `scale3d(.1, .1, .1) translate3d(0, {{ a }}, 0)`,
            offset: 0
        }),
        style({
            opacity: 1,
            transform: `scale3d(.475, .475, .475) translate3d(0, {{ b }}, 0)`,
            offset: 0.6
        })
    ])), { params: { timing: DEFAULT_TIMING, delay: 0, a, b } });
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function zoomInX(a, b) {
    return animation(animate('{{ timing }}s {{ delay }}s cubic-bezier(0.550, 0.055, 0.675, 0.190)', keyframes([
        style({
            opacity: 0,
            transform: `scale3d(.1, .1, .1) translate3d({{ a }}, 0, 0)`,
            offset: 0
        }),
        style({
            opacity: 1,
            transform: `scale3d(.475, .475, .475) translate3d({{ b }}, 0, 0)`,
            offset: 0.6
        })
    ])), { params: { timing: DEFAULT_TIMING, delay: 0, a, b } });
}
const /** @type {?} */ zoomInDown = zoomInY('-1000px', '10px');
const /** @type {?} */ zoomInUp = zoomInY('1000px', '-10px');
const /** @type {?} */ zoomInLeft = zoomInX('-1000px', '10px');
const /** @type {?} */ zoomInRight = zoomInX('1000px', '-10px');
const /** @type {?} */ zoomOut = animation([
    animate('{{ timing }}s {{ delay }}s', keyframes([
        style({
            opacity: 1,
            offset: 0
        }),
        style({
            opacity: 0,
            transform: 'scale3d(.3, .3, .3)',
            offset: 0.5
        }),
        style({
            opacity: 0,
            offset: 1
        })
    ]))
], {
    params: { timing: DEFAULT_TIMING, delay: 0 }
});
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function zoomOutY(a, b) {
    return animation(animate('{{ timing }}s {{ delay }}s cubic-bezier(0.550, 0.055, 0.675, 0.190)', keyframes([
        style({
            opacity: 1,
            transform: `scale3d(.475, .475, .475) translate3d(0, {{ a }}, 0)`,
            offset: 0.4
        }),
        style({
            opacity: 0,
            transform: `scale3d(.1, .1, .1) translate3d(0, {{ b }}, 0)`,
            offset: 1
        })
    ])), { params: { timing: DEFAULT_TIMING, delay: 0, a, b } });
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function zoomOutX(a, b) {
    return animation(animate('{{ timing }}s {{ delay }}s cubic-bezier(0.550, 0.055, 0.675, 0.190)', keyframes([
        style({
            opacity: 1,
            transform: `scale3d(.475, .475, .475) translate3d({{ a }}, 0, 0)`,
            offset: 0.4
        }),
        style({
            opacity: 0,
            transform: `scale3d(.1, .1, .1) translate3d({{ b }}, 0, 0)`,
            offset: 1
        })
    ])), { params: { timing: DEFAULT_TIMING, delay: 0, a, b } });
}
const /** @type {?} */ zoomOutDown = zoomOutY('-60px', '2000px');
const /** @type {?} */ zoomOutUp = zoomOutY('60px', '-2000px');
const /** @type {?} */ zoomOutLeft = zoomOutX('42px', '-2000px');
const /** @type {?} */ zoomOutRight = zoomOutX('-42px', '2000px');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { bounce, flash, pulse, rubberBand, shake, swing, tada, wobble, jello, bounceIn, bounceInY, bounceInX, bounceInDown, bounceInUp, bounceInLeft, bounceInRight, bounceOut, bounceOutY, bounceOutX, bounceOutDown, bounceOutUp, bounceOutLeft, bounceOutRight, fadeInX, fadeInY, fadeIn, fadeInDown, fadeInUp, fadeInLeft, fadeInRight, fadeOutX, fadeOutY, fadeOut, fadeOutDown, fadeOutUp, fadeOutLeft, fadeOutRight, slideX, slideY, slideInUp, slideInDown, slideInLeft, slideInRight, slideOutUp, slideOutDown, slideOutLeft, slideOutRight, flip, flipIn, flipInX, flipInY, flipOut, flipOutX, flipOutY, lightSpeedIn, lightSpeedOut, rotateInDirection, rotateIn, rotateInDownLeft, rotateInDownRight, rotateInUpLeft, rotateInUpRight, rotateOutDirection, rotateOut, rotateOutDownLeft, rotateOutDownRight, rotateOutUpLeft, rotateOutUpRight, hinge, jackInTheBox, rollIn, rollOut, zoomIn, zoomInY, zoomInX, zoomInDown, zoomInUp, zoomInLeft, zoomInRight, zoomOut, zoomOutY, zoomOutX, zoomOutDown, zoomOutUp, zoomOutLeft, zoomOutRight, DEFAULT_TIMING as ɵa };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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